export const TranslationsBase = {
    currency: "{{value, currency}}",
    currencyUSD: "{{value, currencyUSD}}",
    number: "{{value, number}}",
    timeFromTime: "{{value, timeFromTime}}",
    timeFromTimestamp: "{{value, timeFromTimestamp}}",
    dateFromDate: "{{value, dateFromDate}}",
    dateFromTimestamp: "{{value, dateFromTimestamp}}",
    dateFriendlyFromTimestamp: "{{value, dateFriendlyFromTimestamp}}",
    datetimeFromTimestamp: "{{value, datetimeFromTimestamp}}",
    datetimeFromDateTime: "{{value, datetimeFromDateTime}}",
    relative: "{{value, relative}}",
};
//# sourceMappingURL=base.js.map